import { Timer } from "components/Timer";
import { useTimer } from "hooks/useTimer";
import { useState, useEffect } from "react";
import { FrankenstoryState } from "types/FrankenstoryState";

export const GameTimer = (props: {
    roundEnd?: number;
    votingTimer?: number;
    writingTimer?: number;
    state?: FrankenstoryState;
    pauseSecondsRemaining?: number;
}) => {
    const { roundEnd, votingTimer, writingTimer, state, pauseSecondsRemaining } = props;

    // timer
    const [showTimer, setShowTimer] = useState(false);

    const { seconds, setTimerEnd, setIsPaused } = useTimer({ pauseSecondsRemaining });

    useEffect(() => {
        setTimerEnd(roundEnd);
    }, [roundEnd, setTimerEnd]);

    useEffect(() => {
        if (pauseSecondsRemaining) {
            setIsPaused(true);
        } else {
            setIsPaused(false);
        }
    }, [pauseSecondsRemaining, setIsPaused]);

    // turn the timer on and off as needed
    useEffect(() => {
        // don't show timer if player is loading in
        if (seconds === 0) {
            setShowTimer(false);
        } else if (state === "Writing" || state === "Voting") {
            if (state === "Writing" && writingTimer) {
                setShowTimer(true);
            } else if (state === "Voting" && votingTimer) {
                setShowTimer(true);
            } else {
                setShowTimer(false);
            }
        } else if (state === "Awarding" && seconds) {
            setShowTimer(true);
        } else if (state === "Reporting" && seconds) {
            setShowTimer(true);
        } else if (state === "Prompting" && seconds) {
            setShowTimer(true);
        } else {
            setShowTimer(false);
        }
    }, [roundEnd, writingTimer, votingTimer, state, seconds]);

    return state ? (
        <Timer seconds={seconds} showTimer={showTimer} state={state} pauseSecondsRemaining={pauseSecondsRemaining} />
    ) : null;
};
